export const LoginSymbol = Symbol('login');
